import { render, staticRenderFns } from "./multiBrand.vue?vue&type=template&id=968c9a5c&scoped=true"
import script from "./multiBrand.vue?vue&type=script&lang=js"
export * from "./multiBrand.vue?vue&type=script&lang=js"
import style0 from "./multiBrand.vue?vue&type=style&index=0&id=968c9a5c&prod&lang=scss&scoped=true"
import style1 from "./multiBrand.vue?vue&type=style&index=1&id=968c9a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968c9a5c",
  null
  
)

export default component.exports